
import {VIEW_JOB_LIST_REQUEST, VIEW_JOB_LIST_SUCCESS,VIEW_JOB_LIST_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const ViewJobAction = (id) => {

    return function (dispatch) {
      dispatch({
        type: VIEW_JOB_LIST_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_job_by_jobId?jobId=${id}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: VIEW_JOB_LIST_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const loadAllDetailsPre = (data) => {
    return {
      type: VIEW_JOB_LIST_SUCCESS,
      result: data,
      payload: false,
      loading: false,
      msg: "SUCCESS",
    };
  };